import React, { useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
// import CallIcon from '@mui/icons-material/Call';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AppAppBar from '../../components/layout/AppAppBar';
import coinStackingGif from '../../assets/coin-stacking_20260102111635.gif';


export default function PaymentProcessingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/payment-success');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>

      {/* Common Navbar */}
      <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} />

      <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
        
        <Typography
          variant="h4"
          sx={{
            mb: 4,
            fontWeight: 800,
            fontFamily: 'General-Sans-bold',
            color: '#000',
            position: 'relative',
            display: 'inline-block',
            zIndex: 1,
            fontSize: { xs: '1.6rem', sm: '2.125rem' },
            whiteSpace: 'nowrap'
          }}
        >
          Processing Your Payment...
          <Box
            sx={{
              position: 'absolute',
              bottom: '4px',
              right: '-4px',
              width: '65%',
              height: '14px',
              bgcolor: '#FFC107',
              zIndex: -1,
              borderRadius: '20px'
            }}
          />
        </Typography>

        {/* Coin Stacking GIF */}
        <Box sx={{ width: { xs: 280, sm: 350 }, height: { xs: 280, sm: 350 }, mb: { xs: 6, sm: 8 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={coinStackingGif}
            alt="Processing payment"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </Box>

        {/* Existing design commented out */}
        {/* 
        <Box
          sx={{
            width: '100%',
            maxWidth: 360,
            bgcolor: '#F8F9FA',
            borderRadius: 3,
            p: 1.5,
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            textAlign: 'center',
            mb: 2
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#5C6BC0', letterSpacing: 1, mb: 0 }}>
            HOLD ON!
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#1A237E', mb: 0.5, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
            Unlock Extra <span style={{ color: '#2979FF' }}>$15</span>
          </Typography>
          <Typography variant="caption" sx={{ color: '#757575', display: 'block', mb: 2 }}>
            Complete the steps below to claim your reward.
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#E3F2FD', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CallIcon sx={{ color: '#2979FF', fontSize: '1.2rem' }} />
              </Box>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#424242' }}>Call</Typography>
            </Box>

            <ArrowForwardIcon sx={{ color: '#90CAF9', fontSize: 16 }} />

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#E3F2FD', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <AssignmentIcon sx={{ color: '#2979FF', fontSize: '1.2rem' }} />
              </Box>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#424242' }}>Instructions</Typography>
            </Box>

            <ArrowForwardIcon sx={{ color: '#90CAF9', fontSize: 16 }} />

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#FFF8E1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MonetizationOnIcon sx={{ color: '#FFB300', fontSize: '1.2rem' }} />
              </Box>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#424242' }}>Get Reward</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ width: '100%', maxWidth: 360, px: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#000', mb: 1.5, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            1. Hold on please <span style={{ color: '#2979FF', fontWeight: 700 }}>Don't Uninstall</span> the app.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#000', mb: 1.5, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            2. We will <span style={{ color: '#2979FF', fontWeight: 700 }}>call</span> you.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#000', mb: 1.5, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            3. Follow the <span style={{ color: '#2979FF', fontWeight: 700 }}>instructions</span> on call.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#000', mb: 1.5, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            4. Get <span style={{ color: '#2979FF', fontWeight: 700 }}> Extra $15</span> instantly.
          </Typography>
        </Box>
        */}
      </Container>
      <Helmet>
        {/* <script>
          fbq('track', 'Lead');
        </script> */}
      </Helmet>
    </Box>
  );
}
